import React, { useMemo } from 'react';
import { Grid } from '@tmap/mmm-style-guide/src/Grid';
import { useMediaQuery } from '@tmap/mmm-style-guide/src/useMediaQuery';
import { useTheme } from '@tmap/mmm-style-guide/src/Theming';

import ContributionCard from './contributionCard';
import ContributionCardWide from './contributionCardWide';

const PostGridItems = (props) => {
  const {
    posts,
    pageId,
  } = props;

  const isMobile = useMediaQuery(useTheme().breakpoints.down('md'));

  const cardsToDisplay = useMemo(() => posts.map((post, i) => (
    <Grid item xs={12} key={`post-grid-${post._id}`}>
      {isMobile ? (
        <ContributionCard
          wantAnswerButton={false}
          contribution={post}
          entityUrl={`/c/${post.slug}`}
          key={`contributionCard-${post._id}`}
          pageId={pageId}
          placementId={`post-${i}`}
        />
      ) : (
        <ContributionCardWide
          wantAnswerButton={false}
          contribution={post}
          entityUrl={`/c/${post.slug}`}
          key={`contributionCard-${post._id}`}
          pageId={pageId}
          placementId={`post-${i}`}
        />
      )}
    </Grid>
  )), [posts, pageId, isMobile]);

  return cardsToDisplay;
};

export default PostGridItems;
